import axios from '../../bootstrap';

export function wexPageTree() {
    return axios.get('/api/admin/wex/page/tree').then(result => result.data);
}

export function wexPageRecently() {
    return axios
        .get('/api/admin/wex/page/recently')
        .then(result => result.data);
}

export function wexPageNavigation() {
    return axios.get('/api/admin/wex/page/nav').then(result => result.data);
}
